export const translations = {
  EN: {
    specialties: 'Specialties',
    features: 'Features',
    pricing: 'Pricing',
    primaryCare: 'Primary Care',
    dentalClinics: 'Dental Clinics',
    physicalTherapy: 'Physical Therapy',
    mentalHealth: 'Mental Health',
    login: 'Log in',
    tryFree: 'Try 14 days free',
    startNow: 'Start now',
    heroTagline: 'The #1 app for healthcare professionals',
    heroTitle: 'Grow your practice, save time, engage your patients',
    heroDescription:
      'The complete platform for modern healthcare providers. Schedule appointments, manage patients, and grow your practice with powerful tools designed for you.',
    startFreeTrial: 'Start your free trial',
    scheduleDemo: 'Schedule a call',
    trustedBy: 'Trusted by over 5,000 healthcare providers',
    noCreditCard: 'No credit card required',
    cancelAnytime: 'Cancel anytime',
    hipaaCompliant: 'HIPAA compliant',
    // Stats translations
    statsDaysSaved: 'Saved per week',
    statsCustomerSatisfaction: 'Customer Satisfaction',
    statsSupportAvailable: 'Support Available',
    days: 'days',
    // Features section
    featuresTitle: 'Everything you need to run your practice',
    featuresSubtitle:
      'Powerful features designed specifically for healthcare providers to streamline operations and improve patient care.',
    uploadServices: 'Upload Your Services',
    uploadServicesDesc:
      'Let your patients book appointments in your available time slots and manage your schedule efficiently',
    patientHistory: 'Patient History Access',
    patientHistoryDesc:
      'Healthcare professionals can access complete patient history and medical records',
    patientComm: 'Patient Communication',
    patientCommDesc:
      'Automated appointment reminders and secure messaging with patients',
    practiceAnalytics: 'Practice Analytics',
    practiceAnalyticsDesc:
      'Real-time insights into your practice performance and patient engagement',
    brandCustomization: 'Brand Customization',
    brandCustomizationDesc:
      'Customize with your logo and colors, and get a personalized website that matches your preferences',
    hipaaCompliantFeature: 'HIPAA Compliant',
    hipaaCompliantFeatureDesc:
      'Enterprise-grade security ensuring patient data protection',
    // Product section
    productTitle: 'Powerful analytics to grow your practice',
    productDescription:
      'Get detailed insights into your practice performance, patient satisfaction, and revenue trends. Make data-driven decisions to optimize your operations.',
    revenueAnalyticsTitle: 'Revenue Analytics',
    revenueAnalyticsDesc:
      "Track your practice's financial performance with detailed revenue reports",
    patientInsightsTitle: 'Patient Insights',
    patientInsightsDesc: 'Understand patient behavior and satisfaction trends',
    schedulingOptimizationTitle: 'Scheduling Optimization',
    schedulingOptimizationDesc:
      'Identify peak hours and optimize your availability',
    // Pricing section
    pricingTitle: 'Choose the plan that best suits you',
    pricingDescription:
      'Grow your practice with the #1 app for healthcare professionals, clinics, and medical centers.',
    monthly: 'Monthly',
    annual: 'Annual',
    annualDiscount: '(25% off)',
    priceDisclaimer: '*Annual payment. VAT not included.',
    trustedProviders: 'More than 5,000 healthcare providers',
    tryWithoutLimits: 'Try without limits',
    noCreditCardRequired: 'No credit card required',
    cancelAtAnyTime: 'Cancel at any time',
    tryFreeDays: 'Try 14 days for free',
    // Plan features
    upToPatients: 'Up to ${count} patients',
    unlimitedPatients: 'Unlimited patients',
    appointmentScheduling: 'Appointment scheduling',
    patientRecords: 'Patient records',
    emailReminders: 'Email reminders',
    basicReporting: 'Basic reporting',
    emailSupport: 'Email support',
    everythingInBasic: 'Everything in Basic',
    customBranding: 'Custom branding',
    advancedAnalytics: 'Advanced analytics',
    smsReminders: 'SMS reminders',
    prioritySupport: 'Priority support',
    teamManagement: 'Team management',
    everythingInProfessional: 'Everything in Professional',
    customIntegrations: 'Custom integrations',
    dedicatedManager: 'Dedicated account manager',
    slaGuarantee: 'SLA guarantee',
    hipaaCompliance: 'HIPAA compliance',
    apiAccess: 'API access',
    perMonth: '/month*',
    mostPopular: 'Most Popular',
    // FAQ section
    faqTitle: "Got Questions? We've Got Answers",
    faqSubtitle:
      'Everything you need to know about AppointDoc and how it can transform your practice',
    stillHaveQuestions: 'Still have questions?',
    contactSupport: 'Contact our support team',
    // FAQ questions and answers
    faqHipaaQuestion: 'Is AppointDoc HIPAA compliant?',
    faqHipaaAnswer:
      'Yes, AppointDoc is fully HIPAA compliant. We implement all required security measures, including data encryption, access controls, and audit trails to protect patient information. Our platform undergoes regular security audits to maintain compliance.',
    faqSetupQuestion: 'How long does it take to set up?',
    faqSetupAnswer:
      'Most practices are up and running within 24 hours. Our onboarding team will guide you through the setup process, including data migration, staff training, and customization of your workflow. We also provide comprehensive documentation and video tutorials.',
    faqImportQuestion: 'Can I import my existing patient data?',
    faqImportAnswer:
      'Yes, AppointDoc supports importing patient data from most major healthcare management systems. We provide tools and assistance for secure data migration, ensuring a smooth transition without disrupting your practice.',
    faqSupportQuestion: 'What kind of support do you offer?',
    faqSupportAnswer:
      'We offer multiple levels of support based on your plan. All customers receive email support with 24-hour response times. Professional and Enterprise plans include priority support with faster response times, phone support, and dedicated account managers.',
    faqCustomizeQuestion: 'Can I customize the system for my specialty?',
    faqCustomizeAnswer:
      'AppointDoc is highly customizable to accommodate different medical specialties. You can customize appointment types, patient forms, workflow automation, and reporting to match your specific needs. Our Enterprise plan also offers custom integrations.',
    faqTrialQuestion: 'What happens after the free trial?',
    faqTrialAnswer:
      "After the 14-day free trial, you can choose to subscribe to any of our plans. There's no automatic charging - you'll need to explicitly choose a plan to continue using AppointDoc. You can export your data at any time if you decide not to continue.",
    ctaTitle: 'Ready to transform your healthcare practice?',
    // Footer translations
    product: 'Product',
    platform: 'Platform',
    company: 'Company',
    aboutUs: 'About Us',
    careers: 'Careers',
    press: 'Press',
    contact: 'Contact',
    partners: 'Partners',
    enterprise: 'Enterprise',
    customerStories: 'Customer Stories',
    apiDocumentation: 'API Documentation',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    cookieSettings: 'Cookie Settings',
    allRightsReserved: 'All rights reserved.',
  },
  ES: {
    specialties: 'Especialidades',
    features: 'Características',
    pricing: 'Precios',
    primaryCare: 'Atención Primaria',
    dentalClinics: 'Clínicas Dentales',
    physicalTherapy: 'Terapia Física',
    mentalHealth: 'Salud Mental',
    login: 'Iniciar sesión',
    tryFree: 'Prueba 14 días gratis',
    startNow: 'Empezar ahora',
    heroTagline: 'La aplicación #1 para profesionales de la salud',
    heroTitle:
      'Haz crecer tu consulta, ahorra tiempo, conecta con tus pacientes',
    heroDescription:
      'La plataforma completa para profesionales de la salud modernos. Agenda citas, gestiona pacientes y haz crecer tu consulta con herramientas poderosas diseñadas para ti.',
    startFreeTrial: 'Comienza tu prueba gratis',
    scheduleDemo: 'Agenda una llamada',
    trustedBy: 'Respaldado por más de 5,000 profesionales de la salud',
    noCreditCard: 'Sin tarjeta de crédito',
    cancelAnytime: 'Cancela cuando quieras',
    hipaaCompliant: 'Cumple con HIPAA',
    // Stats translations
    statsDaysSaved: 'Ahorrados por semana',
    statsCustomerSatisfaction: 'Satisfacción del Cliente',
    statsSupportAvailable: 'Soporte Disponible',
    days: 'días',
    // Features section
    featuresTitle: 'Todo lo que necesitas para gestionar tu consulta',
    featuresSubtitle:
      'Características poderosas diseñadas específicamente para profesionales de la salud para optimizar operaciones y mejorar la atención al paciente.',
    uploadServices: 'Sube tus Servicios',
    uploadServicesDesc:
      'Permite que tus pacientes reserven citas en tu horario disponible y gestiona tu agenda eficientemente',
    patientHistory: 'Acceso al Historial',
    patientHistoryDesc:
      'Los profesionales de la salud pueden acceder al historial completo y registros médicos del paciente',
    patientComm: 'Comunicación con Pacientes',
    patientCommDesc:
      'Recordatorios automáticos de citas y mensajería segura con pacientes',
    practiceAnalytics: 'Análisis de Consulta',
    practiceAnalyticsDesc:
      'Información en tiempo real sobre el rendimiento de tu consulta y la participación de los pacientes',
    brandCustomization: 'Personalización de Marca',
    brandCustomizationDesc:
      'Personaliza con tu logo y colores, y obtén un sitio web según tus preferencias',
    hipaaCompliantFeature: 'Cumple con HIPAA',
    hipaaCompliantFeatureDesc:
      'Seguridad de nivel empresarial que garantiza la protección de datos del paciente',
    // Product section
    productTitle: 'Análisis potentes para hacer crecer tu consulta',
    productDescription:
      'Obtén información detallada sobre el rendimiento de tu consulta, la satisfacción del paciente y las tendencias de ingresos. Toma decisiones basadas en datos para optimizar tus operaciones.',
    revenueAnalyticsTitle: 'Análisis de Ingresos',
    revenueAnalyticsDesc:
      'Monitorea el rendimiento financiero de tu consulta con informes detallados',
    patientInsightsTitle: 'Información de Pacientes',
    patientInsightsDesc:
      'Comprende el comportamiento y las tendencias de satisfacción de los pacientes',
    schedulingOptimizationTitle: 'Optimización de Agenda',
    schedulingOptimizationDesc:
      'Identifica las horas pico y optimiza tu disponibilidad',
    // Pricing section
    pricingTitle: 'Elige el plan que mejor se adapte a ti',
    pricingDescription:
      'Haz crecer tu consulta con la aplicación #1 para profesionales de la salud, clínicas y centros médicos.',
    monthly: 'Mensual',
    annual: 'Anual',
    annualDiscount: '(25% descuento)',
    priceDisclaimer: '*Pago anual. IVA no incluido.',
    trustedProviders: 'Más de 5,000 profesionales de la salud',
    tryWithoutLimits: 'Prueba sin límites',
    noCreditCardRequired: 'Sin tarjeta de crédito',
    cancelAtAnyTime: 'Cancela cuando quieras',
    tryFreeDays: 'Prueba 14 días gratis',
    // Plan features
    upToPatients: 'Hasta ${count} pacientes',
    unlimitedPatients: 'Pacientes ilimitados',
    appointmentScheduling: 'Agenda de citas',
    patientRecords: 'Registros de pacientes',
    emailReminders: 'Recordatorios por email',
    basicReporting: 'Informes básicos',
    emailSupport: 'Soporte por email',
    everythingInBasic: 'Todo lo del plan Básico',
    customBranding: 'Personalización de marca',
    advancedAnalytics: 'Análisis avanzados',
    smsReminders: 'Recordatorios por SMS',
    prioritySupport: 'Soporte prioritario',
    teamManagement: 'Gestión de equipo',
    everythingInProfessional: 'Todo lo del plan Profesional',
    customIntegrations: 'Integraciones personalizadas',
    dedicatedManager: 'Gestor de cuenta dedicado',
    slaGuarantee: 'Garantía de SLA',
    hipaaCompliance: 'Cumplimiento HIPAA',
    apiAccess: 'Acceso a API',
    perMonth: '/mes*',
    mostPopular: 'Más Popular',
    // FAQ section
    faqTitle: '¿Tienes Preguntas? Tenemos Respuestas',
    faqSubtitle:
      'Todo lo que necesitas saber sobre AppointDoc y cómo puede transformar tu consulta',
    stillHaveQuestions: '¿Aún tienes preguntas?',
    contactSupport: 'Contacta a nuestro equipo de soporte',
    // FAQ questions and answers
    faqHipaaQuestion: '¿AppointDoc cumple con HIPAA?',
    faqHipaaAnswer:
      'Sí, AppointDoc cumple completamente con HIPAA. Implementamos todas las medidas de seguridad requeridas, incluyendo encriptación de datos, controles de acceso y registros de auditoría para proteger la información del paciente. Nuestra plataforma se somete a auditorías de seguridad regulares para mantener el cumplimiento.',
    faqSetupQuestion: '¿Cuánto tiempo toma configurarlo?',
    faqSetupAnswer:
      'La mayoría de las consultas están funcionando en 24 horas. Nuestro equipo de incorporación te guiará durante el proceso de configuración, incluyendo la migración de datos, capacitación del personal y personalización de tu flujo de trabajo. También proporcionamos documentación completa y tutoriales en video.',
    faqImportQuestion: '¿Puedo importar mis datos existentes de pacientes?',
    faqImportAnswer:
      'Sí, AppointDoc admite la importación de datos de pacientes desde la mayoría de los sistemas de gestión de salud principales. Proporcionamos herramientas y asistencia para una migración segura de datos, asegurando una transición sin problemas sin interrumpir tu práctica.',
    faqSupportQuestion: '¿Qué tipo de soporte ofrecen?',
    faqSupportAnswer:
      'Ofrecemos múltiples niveles de soporte según tu plan. Todos los clientes reciben soporte por correo electrónico con tiempos de respuesta de 24 horas. Los planes Professional y Enterprise incluyen soporte prioritario con tiempos de respuesta más rápidos, soporte telefónico y gerentes de cuenta dedicados.',
    faqCustomizeQuestion:
      '¿Puedo personalizar el sistema para mi especialidad?',
    faqCustomizeAnswer:
      'AppointDoc es altamente personalizable para adaptarse a diferentes especialidades médicas. Puedes personalizar tipos de citas, formularios de pacientes, automatización de flujo de trabajo e informes para que coincidan con tus necesidades específicas. Nuestro plan Enterprise también ofrece integraciones personalizadas.',
    faqTrialQuestion: '¿Qué sucede después de la prueba gratuita?',
    faqTrialAnswer:
      'Después de la prueba gratuita de 14 días, puedes elegir suscribirte a cualquiera de nuestros planes. No hay cobros automáticos: deberás elegir explícitamente un plan para continuar usando AppointDoc. Puedes exportar tus datos en cualquier momento si decides no continuar.',
    ctaTitle: '¿Listo para transformar tu consulta médica?',
    // Footer translations
    product: 'Producto',
    platform: 'Plataforma',
    company: 'Empresa',
    aboutUs: 'Sobre Nosotros',
    careers: 'Carreras',
    press: 'Prensa',
    contact: 'Contacto',
    partners: 'Socios',
    enterprise: 'Empresas',
    customerStories: 'Casos de Éxito',
    apiDocumentation: 'Documentación API',
    privacyPolicy: 'Política de Privacidad',
    termsOfService: 'Términos de Servicio',
    cookieSettings: 'Configuración de Cookies',
    allRightsReserved: 'Todos los derechos reservados.',
  },
};
